// Contact-method helpers for the Customer UI user-management flows.
//
// Backend valid types (ContactMethod.valid_types): email, mobile, phone, teams,
// slack. The Customer UI only *creates* email / mobile / phone; slack and teams
// are added in the Back Office and shown here read-only.

// Labels name the delivery channel rather than the device: "mobile" is reached by
// text message, "phone" by an automated voice call.
export const ADDABLE_CONTACT_TYPES = [
  { text: "Email", value: "email" },
  { text: "Text Message", value: "mobile" },
  { text: "Robo Call", value: "phone" },
];

// Managers sign in and are reached by email or mobile only. A robocall-only
// landline carries no SMS or app, so it is reserved for alert-only Responders and
// excluded from the manager create form.
export const MANAGER_CONTACT_TYPES = ADDABLE_CONTACT_TYPES.filter(
  (t) => t.value !== "phone"
);

const ICONS = {
  email: "mdi-email",
  mobile: "mdi-cellphone",
  phone: "mdi-phone",
  slack: "mdi-slack",
  teams: "mdi-microsoft-teams",
};

export function contactIcon(type) {
  return ICONS[type] || "mdi-card-account-details-outline";
}

const COLORS = {
  email: "blue",
  mobile: "teal",
  phone: "indigo",
  slack: "deep-purple",
  teams: "indigo darken-2",
};

// Accent color for a contact type's avatar/icon.
export function contactColor(type) {
  return COLORS[type] || "blue-grey";
}

// Human label for a contact type (e.g. "email" -> "Email").
export function contactTypeLabel(type) {
  const found = ADDABLE_CONTACT_TYPES.find((t) => t.value === type);
  if (found) return found.text;
  if (type === "slack") return "Slack";
  if (type === "teams") return "Teams";
  return type;
}

export function contactValueLabel(type) {
  if (type === "email") return "Email address";
  if (type === "mobile") return "Mobile number";
  return "Phone number";
}

// Back-Office-only types are shown but cannot be edited/removed from the Customer UI.
export function isEditableContact(type) {
  return type !== "slack" && type !== "teams";
}
